export const breathingVoiceScripts = {
  fr: {
    square: {
      intro: "Nous allons pratiquer la respiration carrée.",
      inhale: "Inspirez… pendant quatre secondes…",
      hold1: "Retenez… quatre secondes…",
      exhale: "Expirez… quatre secondes…",
      hold2: "Retenez… encore quatre secondes…",
      outro: "Très bien… continuez à votre rythme…"
    },
    fourSevenEight: {
      intro: "Nous allons pratiquer la respiration quatre-sept-huit pour apaiser le système nerveux.",
      inhale: "Inspirez… quatre secondes…",
      hold: "Retenez… sept secondes…",
      exhale: "Expirez lentement… pendant huit secondes…",
      outro: "Laissez votre corps se détendre un peu plus à chaque cycle…"
    },
    deep: {
      intro: "Nous allons pratiquer une respiration profonde.",
      inhale: "Inspirez profondément… six secondes…",
      exhale: "Expirez… pendant six secondes… en relâchant les tensions…",
      outro: "Sentez votre respiration devenir plus ample, plus fluide…"
    },
    slow: {
      intro: "Nous allons ralentir la respiration.",
      inhale: "Inspirez… six secondes… calmement…",
      exhale: "Expirez… six secondes… en douceur…",
      outro: "Très bien… restez avec cette respiration lente et régulière…"
    },
    sleep: {
      intro: "Nous allons pratiquer la respiration quatre-sept-huit.",
      inhale: "Inspirez… quatre secondes…",
      hold1: "Retenez… sept secondes…",
      exhale: "Expirez lentement… huit secondes…",
      outro: "Laissez le calme vous envahir…"
    },
    calm: {
      intro: "Nous allons pratiquer une respiration anti-stress.",
      inhale: "Inspirez… quatre secondes…",
      hold1: "Retenez… deux secondes…",
      exhale: "Expirez… six secondes…",
      outro: "Sentez le stress s'évacuer à chaque expiration…"
    },
    energize: {
      intro: "Nous allons pratiquer une respiration énergétique.",
      inhale: "Inspirez… trois secondes…",
      exhale: "Expirez… trois secondes…",
      outro: "Sentez l'énergie circuler dans votre corps…"
    },
    cardiac: {
      intro: "Nous allons entrer en cohérence cardiaque.",
      inhale: "Inspirez… cinq secondes…",
      exhale: "Expirez… cinq secondes…",
      outro: "Continuez… laissez votre souffle trouver son propre rythme équilibré…"
    },
    tactical: {
      intro: "Nous allons pratiquer une respiration de stabilisation.",
      inhale: "Inspirez… quatre secondes…",
      hold1: "Maintenez… quatre secondes…",
      exhale: "Expirez… quatre secondes…",
      hold2: "Gardez… encore quatre secondes…",
      outro: "Très bien… sentez-vous plus ancré, plus stable…"
    },
    resonant: {
      intro: "Nous allons pratiquer une respiration douce et résonante.",
      inhale: "Inspirez… tranquillement…",
      exhale: "Expirez… en relâchant les tensions…",
      outro: "Laissez votre souffle devenir comme une vague régulière…"
    },
    guided: {
      intro: "Commençons ensemble ce moment de respiration guidée.",
      inhale: "Inspirez doucement… en laissant l'air remplir votre poitrine…",
      hold: "Retenez un instant… sans forcer…",
      exhale: "Expirez… relâchez tout ce dont vous n'avez plus besoin…",
      outro: "Bravo… revenez à présent tranquillement à votre respiration naturelle…"
    }
  },
  en: {
    square: {
      intro: "We will practice box breathing.",
      inhale: "Breathe in… for four seconds…",
      hold1: "Hold… for four seconds…",
      exhale: "Breathe out… for four seconds…",
      hold2: "Hold again… for four seconds…",
      outro: "Very good… keep going at your own pace…"
    },
    fourSevenEight: {
      intro: "We will practice four-seven-eight breathing to calm your nervous system.",
      inhale: "Breathe in… for four seconds…",
      hold: "Hold… for seven seconds…",
      exhale: "Breathe out slowly… for eight seconds…",
      outro: "Let your body soften a little more with each cycle…"
    },
    deep: {
      intro: "We will practice deep breathing.",
      inhale: "Breathe in deeply… for six seconds…",
      exhale: "Breathe out… for six seconds… releasing any tension…",
      outro: "Feel your breath becoming fuller and more fluid…"
    },
    slow: {
      intro: "We will slow down the breath.",
      inhale: "Breathe in… for six seconds… calmly…",
      exhale: "Breathe out… for six seconds… gently…",
      outro: "Very good… stay with this slow and steady breath…"
    },
    sleep: {
      intro: "We will practice four-seven-eight breathing.",
      inhale: "Breathe in… for four seconds…",
      hold1: "Hold… for seven seconds…",
      exhale: "Breathe out slowly… for eight seconds…",
      outro: "Let the calm wash over you…"
    },
    calm: {
      intro: "We will practice anti-stress breathing.",
      inhale: "Breathe in… for four seconds…",
      hold1: "Hold… for two seconds…",
      exhale: "Breathe out… for six seconds…",
      outro: "Feel the stress leaving with each exhale…"
    },
    energize: {
      intro: "We will practice energizing breathing.",
      inhale: "Breathe in… for three seconds…",
      exhale: "Breathe out… for three seconds…",
      outro: "Feel the energy flowing through your body…"
    },
    cardiac: {
      intro: "We will practice coherent breathing.",
      inhale: "Breathe in… for five seconds…",
      exhale: "Breathe out… for five seconds…",
      outro: "Keep going… let your breath find its own balanced rhythm…"
    },
    tactical: {
      intro: "We will practice a stabilizing breath.",
      inhale: "Breathe in… for four seconds…",
      hold1: "Hold… for four seconds…",
      exhale: "Breathe out… for four seconds…",
      hold2: "Hold again… for four seconds…",
      outro: "Very good… feel more grounded and stable…"
    },
    resonant: {
      intro: "We will practice a soft resonant breathing.",
      inhale: "Breathe in… gently…",
      exhale: "Breathe out… releasing tension…",
      outro: "Let your breath become like a smooth, regular wave…"
    },
    guided: {
      intro: "Let's begin this guided breathing moment together.",
      inhale: "Gently breathe in… letting the air fill your chest…",
      hold: "Hold for a moment… without forcing…",
      exhale: "Breathe out… letting go of what you no longer need…",
      outro: "Well done… now slowly return to your natural breath…"
    }
  }
};
